import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-pre-cancel-dialog',
    template: require('./dialogPreCancel.html')
})

export class DialogPreCancelComponent{

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<DialogPreCancelComponent>) public dialogRef: MatDialogRef<DialogPreCancelComponent>) {}

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }

}
